import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';

export const PageContainer = styled(Flex, {
  background: '#FAFCFF',
  height: '384px',
  flexDirection: 'column',
  alignItems: 'center',
  '@media (max-width: 464px)': {
    paddingTop: '$md',
    paddingLeft: '$lg',
    alignItems: 'flex-start',
    flexDirection: 'row-reverse',
    minHeight: '229px',
    height: 'fit-content',
    paddingBottom: '24px',
  },
});

export const PageContent = styled(Flex, {
  alignContent: 'center',
  alignItems: 'center',
  flex: 1,
  flexDirection: 'column',
  '@media (max-width: 464px)': {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
  },
});
